export default __webpack_public_path__ + "static/media/blast_logo.799dd5a0.svg";